import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicRoutingModule } from './public-routing.module';
import { SupportComponent } from './support/support.component';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';

@NgModule({
  declarations: [SupportComponent, LoginComponent],
  imports: [CommonModule, PublicRoutingModule, SharedModule, CoreModule],
  exports: [LoginComponent],
})
export class PublicModule {}
